import { j as e } from "../../../../jsx-runtime-BwWtxLpl.js";
import { useContext as d, useEffect as x } from "react";
import r from "prop-types";
import u from "classnames";
import { IconoirSearch as S } from "@ey-xd/motif-icon";
import { SelectCheckbox as C } from "../checkbox/checkbox.js";
import { SelectContext as j } from "../select-context.js";
import { MotifIcon as b } from "../../../icon/icon.js";
import "../../../icon/icon.context.js";
const k = ({ icons: c = {} }) => {
  const {
    id: a,
    multiple: i,
    searchPlaceholder: l,
    searchOption: n,
    handleChangeSearch: m,
    isOpen: t,
    hasSelectedAllOptions: o,
    handleClickSearchCheckbox: p,
    totalOptions: h,
    selectSearchRef: s
  } = d(j);
  x(() => {
    t && s.current.focus();
  }, [t]);
  const f = u({
    "motif-select-search": !0,
    "motif-select-search-no-results": h === 0
  });
  return /* @__PURE__ */ e.jsxs("div", { className: f, children: [
    i && /* @__PURE__ */ e.jsx(
      C,
      {
        onClick: p,
        selected: o.selected,
        indeterminate: o.indeterminate
      }
    ),
    /* @__PURE__ */ e.jsx(
      "input",
      {
        ref: s,
        className: "motif-select-search-input",
        type: "text",
        role: "combobox",
        "aria-autocomplete": "list",
        "aria-expanded": t,
        "aria-controls": `${a}-listbox`,
        placeholder: l,
        value: n,
        onChange: m
      }
    ),
    c.search || /* @__PURE__ */ e.jsx(b, { iconFunction: S, className: "motif-select-search-icon" })
  ] });
};
k.propTypes = {
  icons: r.shape({
    search: r.node
  })
};
export {
  k as SelectSearch
};
